import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { SharedDataService } from '../../../services/sharedData/shared-data.service';
import { MatStepper } from '@angular/material/stepper'
import { MobileDetectorService } from '../../../services/mobileDetector/mobile-detector.service';
import { Subscription } from 'rxjs';



@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit, OnDestroy {

  isLinear: boolean = true;
  isMobile: boolean = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  fourthFormGroup: FormGroup;

  @ViewChild('stepper') private myStepper: MatStepper;

  private sharedData$: Subscription;

  constructor(
    private _formBuilder: FormBuilder,
    private sharedData: SharedDataService,
    private mobileDetectorService: MobileDetectorService,
    ) { }

  ngOnInit(): void {
    let foundMode = sessionStorage.getItem('mode');
    this.sharedData.changeMessage("");
    if(foundMode) {
      sessionStorage.clear();
      window.location.reload();
    }
    this.isMobile = this.mobileDetectorService.isMobile();
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['',Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
    this.thirdFormGroup = this._formBuilder.group({
      thirdCtrl: ['', Validators.required]
    });
    this.fourthFormGroup = this._formBuilder.group({
      fourthCtrl: ['', Validators.required]
    });

    this.sharedData$ = this.sharedData.currentMessage.subscribe(message => {

      if(message==="saveStep1" ) {
        this.saveStep('firstCtrl');
      }
      if(message==="step1valid") {
        this.removeValidators('firstCtrl');
      }
      if(message==="step1invalid") {
        this.addValidators('firstCtrl');
      }


      if(message==="saveStep2") {
        this.saveStep('secondCtrl');
      }
      if(message==="step2valid") {
        this.removeValidators('secondCtrl');
      }
      if(message==="step2invalid") {
        this.addValidators('secondCtrl');
      }


      if(message==="saveStep3") {
        this.saveStep('thirdCtrl');
      }
      if(message==="step3valid") {
        this.removeValidators('thirdCtrl');
      }
      if(message==="step3invalid") {
        this.addValidators('thirdCtrl');
      }


      if(message==="saveStep4") {
        this.saveStep('fourthCtrl');
      }
      if(message==="step4valid") {
        this.removeValidators('fourthCtrl');
      }
      if(message==="step4invalid") {
        this.addValidators('fourthCtrl');
      }
      
      });
  }

  saveStep(form: string) {
    this.removeValidators(form);
    this.myStepper.next();
  }
  
  addValidators(form: string) {

    if(form==='firstCtrl') {
      this.firstFormGroup.get(form).addValidators(Validators.required);
      this.firstFormGroup.get(form).updateValueAndValidity();
    }
    if(form==='secondCtrl') {
      this.secondFormGroup.get(form).addValidators(Validators.required);
      this.secondFormGroup.get(form).updateValueAndValidity();
    }
    if(form==='thirdCtrl') {
      this.thirdFormGroup.get(form).addValidators(Validators.required);
      this.thirdFormGroup.get(form).updateValueAndValidity();
    }
    if(form==='fourthCtrl') {
      this.fourthFormGroup.get(form).addValidators(Validators.required);
      this.fourthFormGroup.get(form).updateValueAndValidity();
    }
  }

  removeValidators(form: string) {

    if(form==='firstCtrl') {
      this.firstFormGroup.get(form).clearValidators();
      this.firstFormGroup.get(form).updateValueAndValidity();
    }
    if(form==='secondCtrl') {
      this.secondFormGroup.get(form).clearValidators();
      this.secondFormGroup.get(form).updateValueAndValidity();
    }
    if(form==='thirdCtrl') {
      this.thirdFormGroup.get(form).clearValidators();
      this.thirdFormGroup.get(form).updateValueAndValidity();
    }
    if(form==='fourthCtrl') {
      this.fourthFormGroup.get(form).clearValidators();
      this.fourthFormGroup.get(form).updateValueAndValidity();
    }
  }

  onSelectionChange() {
    this.sharedData.changeMessage("saveStep");
  }

  public ngOnDestroy(): void {
    this.sharedData$.unsubscribe();
  }

}